import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { styles } from './styles'

const TableTotals = ({ data }) => {
  const pickStyles = type => {
    switch (type) {
      case 'label':
        return styles.label
      case 'number':
        return styles.value
      case 'string':
        return styles.value
      default:
        return {}
    }
  }
  return (
    <div style={styles.wrapper}>
      {data.map((row, index) => (
        <Row
          style={{
            ...styles.row,
            borderBottom:
              index === data.length - 1 ? 'none' : '1px solid #E2E2FC',
          }}
          key={index}
        >
          {row.map(item => (
            <Col xs={item.xs} style={styles.col(item.align)}>
              <div style={styles.contentWrapper}>
                <div style={pickStyles(item.type)}>{item.label}</div>
              </div>
            </Col>
          ))}
        </Row>
      ))}
    </div>
  )
}

export default TableTotals
